var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Auth0Client, } from '@auth0/auth0-spa-js';
import { FragmentHandler, SUPPORTED_LANGUAGES, getLanguagePathPrefix, oauth, } from '@seek/oauth-url-builders';
import { clearAllCacheValues, getCacheValue } from './Cache.js';
import Client from './Client.js';
import ScopeHandler from './ScopeHandler.js';
import { SEEK_CLAIMS_PREFIX, SEEK_SUB_REGEX } from './constants/index.js';
import version from './constants/version.js';
import { LoginRequiredError, OI_INVALID_GRANT_ERROR, OI_LOGIN_REQUIRED_ERROR, OI_UNAUTHORIZED_CLIENT_ERROR, OI_UNAUTHORIZED_ERROR, } from './errors.js';
import getCookie, { deployCookieMonster } from './modules/cookie.js';
import { defaultNowProvider, isHirer, isSafari, isSeekJobs } from './utils.js';
var AuthN = (function (_super) {
    __extends(AuthN, _super);
    function AuthN(config, setGlobal) {
        if (setGlobal === void 0) { setGlobal = false; }
        var _this = _super.call(this, config) || this;
        _this.functions = {
            goToLogin: _this.goToLogin.bind(_this),
            loginWithScope: _this.loginWithScope.bind(_this),
        };
        _this.scopeHandler = new ScopeHandler();
        var client = _this.getClient();
        _this.auth0Client = client;
        if (setGlobal && window && !window.AuthN) {
            window.AuthN = _this;
        }
        return _this;
    }
    AuthN.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                (_a = this.initPromise) !== null && _a !== void 0 ? _a : (this.initPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                    var e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, 3, 4]);
                                return [4, this.getToken()];
                            case 1:
                                _a.sent();
                                return [3, 4];
                            case 2:
                                e_1 = _a.sent();
                                if (e_1.error !== 'login_required') {
                                    throw e_1;
                                }
                                return [3, 4];
                            case 3:
                                new FragmentHandler({
                                    functions: this.functions,
                                });
                                return [7];
                            case 4: return [2];
                        }
                    });
                }); })());
                return [2, this.initPromise];
            });
        });
    };
    AuthN.prototype.getUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getToken()];
                    case 1:
                        _a.sent();
                        return [4, this.auth0Client.getUser()];
                    case 2: return [2, _a.sent()];
                }
            });
        });
    };
    AuthN.prototype.getIdTokenClaims = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getToken()];
                    case 1:
                        _a.sent();
                        return [4, this.auth0Client.getIdTokenClaims()];
                    case 2: return [2, _a.sent()];
                }
            });
        });
    };
    AuthN.prototype.isAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, Promise.resolve(this.isTokenRefreshPossible())];
            });
        });
    };
    AuthN.prototype.login = function () {
        return __awaiter(this, arguments, void 0, function (_a, dangerouslyOverrideOauthRedirect) {
            var locationToRedirect;
            var _b = _a === void 0 ? {} : _a, additionalArguments = _b.additionalArguments, appState = _b.appState, connection = _b.connection, fragment = _b.fragment, loginTicket = _b.loginTicket, returnUri = _b.returnUri, maxAge = _b.maxAge;
            if (dangerouslyOverrideOauthRedirect === void 0) { dangerouslyOverrideOauthRedirect = false; }
            return __generator(this, function (_c) {
                if (!window.location.pathname.startsWith("".concat(getLanguagePathPrefix(additionalArguments === null || additionalArguments === void 0 ? void 0 : additionalArguments.language), "/oauth/")) &&
                    !dangerouslyOverrideOauthRedirect) {
                    locationToRedirect = location;
                    if (returnUri) {
                        locationToRedirect = {
                            origin: location.origin,
                            pathname: returnUri,
                            search: '',
                        };
                    }
                    return [2, window.location.assign(oauth.buildLoginUrl({
                            location: locationToRedirect,
                            language: additionalArguments === null || additionalArguments === void 0 ? void 0 : additionalArguments.language,
                        }))];
                }
                return [2, this.loginWithClient({
                        additionalArguments: additionalArguments,
                        appState: appState,
                        connection: connection,
                        fragment: fragment,
                        loginTicket: loginTicket,
                        loginType: 'redirect',
                        returnUri: returnUri,
                        maxAge: maxAge,
                    })];
            });
        });
    };
    AuthN.prototype.loginWithPopup = function (fragment, connection, maxAge) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.loginWithClient({
                        connection: connection,
                        fragment: fragment,
                        loginType: 'popup',
                        maxAge: maxAge,
                    })];
            });
        });
    };
    AuthN.prototype.logout = function (returnTo, toOverrideDefaultRedirectPath) {
        return __awaiter(this, void 0, void 0, function () {
            var toOverride, path;
            return __generator(this, function (_a) {
                toOverride = returnTo && returnTo !== '/';
                if (toOverride && toOverrideDefaultRedirectPath) {
                    path = "/oauth/redirect/?returnPath=".concat(returnTo);
                    return [2, window.location.assign(oauth.buildLogoutUrl({ returnPath: path }))];
                }
                this.scopeHandler.clear();
                deployCookieMonster();
                return [2, Promise.resolve(this.auth0Client.logout({
                        clientId: this.config.clientId,
                        logoutParams: {
                            returnTo: returnTo,
                        },
                    }))];
            });
        });
    };
    AuthN.prototype.getToken = function () {
        return __awaiter(this, arguments, void 0, function (_a) {
            var JobseekerSessionId;
            var _b = _a === void 0 ? {} : _a, _c = _b.ignoreCache, ignoreCache = _c === void 0 ? false : _c;
            return __generator(this, function (_d) {
                if (this.isTokenRefreshPossible() === false) {
                    throw new LoginRequiredError();
                }
                JobseekerSessionId = getCookie().JobseekerSessionId;
                return [2, this.auth0Client.getTokenSilently({
                        authorizationParams: {
                            redirect_uri: this.redirectUri,
                            initial_scope: this.getScope(this.scopeHandler.scope),
                            JobseekerSessionId: JobseekerSessionId,
                            identity_sdk_version: version,
                            refresh_href: document.location.href,
                        },
                        cacheMode: ignoreCache ? 'off' : 'on',
                    })];
            });
        });
    };
    AuthN.prototype.handleGetTokenError = function (e) {
        switch (e.code) {
            case OI_INVALID_GRANT_ERROR:
            case OI_LOGIN_REQUIRED_ERROR:
                return this.login();
            case OI_UNAUTHORIZED_CLIENT_ERROR:
                return 'Please ensure the clientId is authorized to use this realm.';
            case OI_UNAUTHORIZED_ERROR:
                return 'Your account has been blocked.';
            default:
                return e.message;
        }
    };
    AuthN.prototype.handleRedirect = function () {
        return __awaiter(this, arguments, void 0, function (redirectHandler) {
            var appState;
            if (redirectHandler === void 0) { redirectHandler = this.defaultRouteHandler; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.auth0Client.handleRedirectCallback()];
                    case 1:
                        appState = (_a.sent()).appState || {};
                        deployCookieMonster();
                        if (appState.additionalScope) {
                            this.scopeHandler.persist(appState.additionalScope);
                        }
                        return [2, redirectHandler("".concat(this.config.__disableHttps ? 'http' : 'https', "://").concat(this.config.clientDomain), appState.returnUri || '/', appState)];
                }
            });
        });
    };
    AuthN.prototype.getIdentity = function () {
        return __awaiter(this, arguments, void 0, function (_a) {
            var claims, subject, userId, actAs;
            var _b = _a === void 0 ? {} : _a, _c = _b.ignoreIdPrefixStrip, ignoreIdPrefixStrip = _c === void 0 ? false : _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4, this.getToken()];
                    case 1:
                        _d.sent();
                        return [4, this.getUser()];
                    case 2:
                        claims = _d.sent();
                        if (!claims) {
                            return [2, null];
                        }
                        subject = __assign(__assign(__assign(__assign(__assign(__assign(__assign({ ID: this.stripIdPrefix(claims.sub) }, (claims['http://seek/claims/user_id'] && {
                            userId: claims['http://seek/claims/user_id'],
                        })), (claims['http://seek/claims/country'] && {
                            country: claims['http://seek/claims/country'],
                        })), (claims['http://seek/claims/brand'] && {
                            brand: claims['http://seek/claims/brand'],
                        })), (claims['http://seek/claims/experience'] && {
                            experience: claims['http://seek/claims/experience'],
                        })), (claims.email && { email: claims.email })), (claims.email_verified && { email_verified: claims.email_verified })), (claims['http://seek/claims/identity_id'] && {
                            identityId: claims['http://seek/claims/identity_id'],
                        }));
                        if (claims['http://seek/claims/act_as/sub']) {
                            userId = claims['http://seek/claims/act_as/sub'];
                            if (!userId || typeof userId !== 'string') {
                                return [2, __assign({ sub: subject }, (claims['http://seek/claims/advertiser_id'] && {
                                        advertiserId: claims['http://seek/claims/advertiser_id'],
                                    }))];
                            }
                            actAs = __assign(__assign(__assign(__assign(__assign(__assign(__assign({ ID: ignoreIdPrefixStrip ? userId : this.stripIdPrefix(userId) }, (claims['http://seek/claims/act_as/user_id'] && {
                                userId: claims['http://seek/claims/act_as/user_id'],
                            })), (claims['http://seek/claims/act_as/country'] && {
                                country: claims['http://seek/claims/act_as/country'],
                            })), (claims['http://seek/claims/act_as/brand'] && {
                                brand: claims['http://seek/claims/act_as/brand'],
                            })), (claims['http://seek/claims/act_as/experience'] && {
                                experience: claims['http://seek/claims/act_as/experience'],
                            })), (claims['http://seek/claims/act_as/email'] && {
                                email: claims['http://seek/claims/act_as/email'],
                            })), (claims['http://seek/claims/act_as/email_verified'] && {
                                email_verified: claims['http://seek/claims/act_as/email_verified'],
                            })), (claims['http://seek/claims/act_as/identity_id'] && {
                                identityId: claims['http://seek/claims/act_as/identity_id'],
                            }));
                            return [2, __assign({ sub: actAs, act: subject }, (claims['http://seek/claims/advertiser_id'] && {
                                    advertiserId: claims['http://seek/claims/advertiser_id'],
                                }))];
                        }
                        return [2, __assign({ sub: subject }, (claims['http://seek/claims/advertiser_id'] && {
                                advertiserId: claims['http://seek/claims/advertiser_id'],
                            }))];
                }
            });
        });
    };
    AuthN.prototype.getTestUserContext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var claims, testRecord, testScope, recordExpiry, testBehaviours;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.getToken()];
                    case 1:
                        _a.sent();
                        return [4, this.getUser()];
                    case 2:
                        claims = _a.sent();
                        if (!claims) {
                            return [2, null];
                        }
                        testRecord = Boolean(claims["".concat(SEEK_CLAIMS_PREFIX, "/user_test_record")]);
                        if (!testRecord) {
                            return [2, { testRecord: testRecord }];
                        }
                        testScope = claims["".concat(SEEK_CLAIMS_PREFIX, "/test_scope")], recordExpiry = claims["".concat(SEEK_CLAIMS_PREFIX, "/user_test_record_expiry")], testBehaviours = claims["".concat(SEEK_CLAIMS_PREFIX, "/user_test_behaviours")];
                        return [2, __assign(__assign(__assign({ testRecord: testRecord }, (testScope && {
                                testScope: testScope,
                            })), (recordExpiry && {
                                recordExpiry: recordExpiry,
                            })), (testBehaviours && {
                                testBehaviours: testBehaviours,
                            }))];
                }
            });
        });
    };
    AuthN.prototype.handleSeamlessSingleSignOn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isAuthenticated, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, this.isAuthenticated()];
                    case 1:
                        isAuthenticated = _b.sent();
                        if (isAuthenticated) {
                            return [2];
                        }
                        this.login({
                            returnUri: window.location.href.replace(window.location.origin, ''),
                        });
                        return [3, 3];
                    case 2:
                        _a = _b.sent();
                        return [2];
                    case 3: return [2];
                }
            });
        });
    };
    AuthN.prototype.isTokenRefreshPossible = function () {
        var cacheValue = getCacheValue({
            clientId: this.config.clientId,
            audience: this.config.audience,
            scope: this.getScope(this.scopeHandler.scope),
        });
        if (!cacheValue) {
            return false;
        }
        return true;
    };
    AuthN.prototype.stripIdPrefix = function (id) {
        var _a;
        var _b = ((_a = SEEK_SUB_REGEX.exec(id)) !== null && _a !== void 0 ? _a : [])[0], match = _b === void 0 ? '' : _b;
        return match;
    };
    AuthN.prototype.loginWithClient = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var scope, returnUriToUse, authorizationParams, JobseekerSessionId, loginOptions;
            var additionalArguments = _b.additionalArguments, additionalScope = _b.additionalScope, _c = _b.appState, appState = _c === void 0 ? {} : _c, connection = _b.connection, fragment = _b.fragment, loginTicket = _b.loginTicket, loginType = _b.loginType, returnUri = _b.returnUri, loginHint = _b.loginHint, referrer = _b.referrer, maxAge = _b.maxAge;
            return __generator(this, function (_d) {
                scope = this.getScope(additionalScope);
                returnUriToUse = returnUri || window.location.pathname + window.location.search;
                authorizationParams = __assign(__assign(__assign({ redirect_uri: this.redirectUri, scope: scope, connection: connection, login_hint: loginHint, login_ticket: loginTicket, ui_locales: (additionalArguments === null || additionalArguments === void 0 ? void 0 : additionalArguments.language)
                        ? SUPPORTED_LANGUAGES[additionalArguments.language]
                        : undefined, referrer: referrer }, additionalArguments), { fragment: fragment }), (maxAge !== undefined && { max_age: maxAge }));
                JobseekerSessionId = getCookie().JobseekerSessionId;
                if (JobseekerSessionId) {
                    authorizationParams.JobseekerSessionId = JobseekerSessionId;
                }
                Object.keys(authorizationParams).forEach(function (key) {
                    if (authorizationParams[key] === undefined) {
                        delete authorizationParams[key];
                    }
                });
                loginOptions = {
                    authorizationParams: authorizationParams,
                    appState: __assign(__assign(__assign({}, appState), { returnUri: returnUriToUse }), (additionalScope && { additionalScope: additionalScope })),
                    fragment: fragment,
                };
                if (isSafari() && loginType === 'redirect') {
                    loginOptions.openUrl = function (url) {
                        window.location.replace(url);
                    };
                }
                return [2, loginType === 'popup'
                        ? this.auth0Client.loginWithPopup(loginOptions)
                        : this.auth0Client.loginWithRedirect(loginOptions)];
            });
        });
    };
    AuthN.prototype.loginWithScope = function (handler) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, realm, returnUri, scope, _b, language, loginHint, referrer, href, client, _c, _d, lang, _e, locale;
            return __generator(this, function (_f) {
                _a = handler.getSearchParams(), realm = _a.realm, returnUri = _a.return_uri, scope = _a.scope, _b = _a.language, language = _b === void 0 ? '' : _b, loginHint = _a.email_hint, referrer = _a.referrer;
                href = returnUri || '/';
                if (/^[^\/]/.test(href)) {
                    href = '/';
                }
                this.scopeHandler.clear();
                clearAllCacheValues();
                client = this.createAuth0Client();
                this.auth0Client = client;
                _c = language.split('-'), _d = _c[0], lang = _d === void 0 ? '' : _d, _e = _c[1], locale = _e === void 0 ? '' : _e;
                return [2, this.loginWithClient(__assign({ loginType: 'redirect', additionalScope: scope, connection: realm, returnUri: href, fragment: FragmentHandler.stringify('/login', {
                            locale: locale.toLowerCase(),
                            language: lang,
                        }) }, (language && {
                        additionalArguments: { language: language },
                        loginHint: loginHint,
                        referrer: referrer,
                    })))];
            });
        });
    };
    AuthN.prototype.goToLogin = function (handler) {
        return __awaiter(this, void 0, void 0, function () {
            var fragments, fragment, returnUri;
            return __generator(this, function (_a) {
                fragments = handler.getSearchParams();
                fragment = handler.getFragmentString();
                returnUri = window.location.pathname;
                if (typeof fragments.return_uri === 'string') {
                    returnUri = fragments.return_uri;
                }
                return [2, this.login({
                        returnUri: returnUri,
                        fragment: fragment,
                    })];
            });
        });
    };
    AuthN.prototype.getClient = function () {
        return this.auth0Client || this.createAuth0Client();
    };
    AuthN.prototype.createAuth0Client = function () {
        var _this = this;
        var isProd = this.config.environment === 'prod';
        var getNowProvider = function () {
            if (_this.config.disableCustomNowProvider === true) {
                return Date.now();
            }
            if (isSeekJobs(_this.config.siteName) || isHirer(_this.config.siteName)) {
                return defaultNowProvider(isProd);
            }
            return Date.now();
        };
        var auth0Client = new Auth0Client({
            domain: this.config.authDomain,
            clientId: this.config.clientId,
            issuer: this.config.issuerOverride,
            cacheLocation: 'localstorage',
            useRefreshTokens: this.config.useRefreshTokens || true,
            useRefreshTokensFallback: true,
            leeway: 120,
            nowProvider: getNowProvider,
            useFormData: false,
            authorizationParams: {
                redirect_uri: this.redirectUri,
                scope: this.getScope(this.scopeHandler.scope),
                audience: this.config.audience,
            },
        });
        return auth0Client;
    };
    AuthN.prototype.getScope = function (additionalScope) {
        if (additionalScope === void 0) { additionalScope = ''; }
        var explicitScope = this.config.scope
            ? "".concat(this.config.scope, " profile email")
            : this.defaultScope;
        var allScopes = "".concat(explicitScope, " ").concat(additionalScope).trim().split(/\s+/);
        var uniqueScopes = Array.from(new Set(allScopes));
        return uniqueScopes.join(' ');
    };
    return AuthN;
}(Client));
export default AuthN;
//# sourceMappingURL=AuthN.js.map